module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/base/base-component/base-component.component.scss
// module id = ./src/app/pages/base/base-component/base-component.component.scss
// module chunks = main